











import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { VAutocomplete, VTextField } from 'vuetify/lib'
import { sortByCodigo, findCSTs } from '@/shareds/fiscal'
import { CST } from '@/models'
import type { TipoDeImposto } from '@/models'

@Component({
	components: {
		VAutocomplete,
		VTextField,
	},
})
export default class SeletorDeCst extends Vue {
	@Prop({ type: String }) tipo!: TipoDeImposto

	cstImposto: CST[] = []

	async created() {
		this.buscarCst()
	}

	get csts() {
		return this.cstImposto.sort(sortByCodigo)
	}

	async buscarCst() {
		this.cstImposto = await findCSTs(this.tipo)
	}

	@Watch('tipo')
	async onChangeTipo(tipoAnterior, tipoAtual) {
		this.buscarCst()

		if (tipoAnterior && tipoAnterior !== tipoAtual) {
			this.$emit('input', null)
		}
	}
}
